import LegalLayout from "./components/LegalLayout";

function Section({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <section className="mb-10">
      <h2 className="text-xl font-bold text-faro-navy mb-4 pb-2 border-b border-faro-gray-mid">{title}</h2>
      <div className="text-faro-gray-text text-sm leading-relaxed space-y-3">{children}</div>
    </section>
  );
}

export default function AvisoLegalPage() {
  return (
    <LegalLayout title="Aviso Legal" lastUpdated="26 de marzo de 2026">
      <Section title="1. Datos del titular del sitio web">
        <p>
          En cumplimiento del artículo 10 de la Ley 34/2002, de 11 de julio, de Servicios de la Sociedad de la Información
          y Comercio Electrónico (LSSICE), se facilitan los siguientes datos de identificación:
        </p>
        <ul className="list-disc list-inside space-y-1 pl-2">
          <li><strong className="text-faro-navy">Denominación social:</strong> Faro Energía</li>
          <li><strong className="text-faro-navy">Nombre comercial:</strong> Faro Energía</li>
          <li><strong className="text-faro-navy">Domicilio:</strong> Castellón de la Plana, Comunitat Valenciana, España</li>
          <li><strong className="text-faro-navy">Correo electrónico:</strong> info@faroenergia.es</li>
          <li><strong className="text-faro-navy">Sitio web:</strong> faroenergia.es</li>
          <li><strong className="text-faro-navy">Actividad:</strong> Consultoría energética independiente</li>
        </ul>
      </Section>

      <Section title="2. Objeto y ámbito de aplicación">
        <p>
          El presente Aviso Legal regula el acceso y uso del sitio web <strong>faroenergia.es</strong>, propiedad de
          Faro Energía. El acceso al sitio web implica la aceptación plena y sin reservas de todas las disposiciones
          incluidas en este Aviso Legal.
        </p>
        <p>
          Faro Energía presta servicios de consultoría energética independiente para particulares, pymes y comunidades
          de propietarios en Castellón de la Plana, Barcelona y otras localidades de España.
        </p>
      </Section>

      <Section title="3. Propiedad intelectual e industrial">
        <p>
          Todos los contenidos del sitio web (textos, imágenes, logotipos, gráficos, diseño, código fuente y demás
          elementos) son propiedad de Faro Energía o de terceros que han autorizado su uso, y están protegidos por
          la normativa española e internacional de propiedad intelectual e industrial.
        </p>
        <p>
          Queda expresamente prohibida la reproducción, distribución, comunicación pública o transformación de dichos
          contenidos sin la autorización escrita previa de Faro Energía, salvo que se trate de un uso personal y
          no comercial.
        </p>
      </Section>

      <Section title="4. Exclusión de responsabilidad">
        <p>
          Faro Energía no garantiza la disponibilidad, continuidad ni infalibilidad del funcionamiento del sitio web,
          y no se responsabiliza de los daños o perjuicios causados al usuario o a terceros por la interrupción,
          suspensión o fallo del sitio web.
        </p>
        <p>
          Asimismo, Faro Energía no se responsabiliza del contenido de sitios web de terceros accesibles mediante
          enlaces desde este sitio web. La existencia de un enlace no implica relación alguna entre Faro Energía
          y el titular del sitio enlazado.
        </p>
      </Section>

      <Section title="5. Hiperenlaces">
        <p>
          Los usuarios que deseen introducir un hiperenlace desde su propio sitio web a <strong>faroenergia.es</strong> deberán
          respetar las siguientes condiciones: el enlace deberá abrir la página en su totalidad, sin marcos; no podrá
          reproducirse el sitio web dentro del sitio del usuario; no se realizarán manifestaciones o indicaciones
          falsas sobre Faro Energía.
        </p>
      </Section>

      <Section title="6. Ley aplicable y jurisdicción">
        <p>
          Este Aviso Legal se rige por la legislación española vigente. Para la resolución de cualquier controversia
          que pudiera derivarse del acceso o uso de este sitio web, las partes se someten a los Juzgados y Tribunales
          de Castellón de la Plana, con renuncia expresa a cualquier otro fuero que pudiera corresponderles.
        </p>
      </Section>

      <Section title="7. Modificaciones">
        <p>
          Faro Energía se reserva el derecho de modificar, en cualquier momento y sin previo aviso, el contenido de
          este Aviso Legal. El usuario deberá leerlo periódicamente para conocer la versión vigente.
        </p>
      </Section>
    </LegalLayout>
  );
}
